import { proxy } from "valtio";

export const engagementContentStore = proxy<{
  selectedAdId: number;
  selectedTodoId: number;
  selectedAudienceId: number;
}>({
  selectedAdId: -1,
  selectedTodoId: -1,
  selectedAudienceId: -1,
});
